module.exports = __webpack_public_path__ + "static/pw3-bb1a9ea4f270d234af3d46052ef9c350.webp";